import { useImageUploader } from '@hooks/useImageKit'
import PropTypes from 'prop-types'

const ImageUploader = ({ onImageUpload }) => {
  const { uploading, error, handleFileChange } = useImageUploader(onImageUpload)

  return (
    <div>
      <label htmlFor='image'>Imagen</label>
      <input type='file' id='image' accept='image/*' disabled={uploading} onChange={handleFileChange} />
      {uploading && <p>Subiendo imagen...</p>}
      {error && <p style={{ color: 'red' }}>{error}</p>}
    </div>
  )
}

ImageUploader.propTypes = {
  onImageUpload: PropTypes.func.isRequired,
}

export default ImageUploader
